import React, { Fragment, memo, useContext, useEffect, useState } from "react";

// Provider
import {
  AppContext,
  LOG_OUT_SUCCESS,
  SocketCommand,
  socketManager,
} from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";

// UI
import { closeLayerFn, ContainerNew, openLayerFn, SubMenu } from "../Layout";

import {
  AlertLayer,
  ConfirmLayer,
  NewAlertLogout,
} from "../../components/UI/Dialog";
import { PostApi108, PostApi1914 } from "../../modules/network/padoPost";
import { ItemOnOffLayer } from "./Main.Layer";
import useTitle from "../../modules/hooks/useTitle";
// useEffect(() => {
const request1914 = (userinfo, cfg, phonecfg, setColumn, setValue, hpKey) => {
  PostApi1914(userinfo, cfg, phonecfg, setColumn, setValue, hpKey)
    .then(res => {
      if (res.resultMsg === "SUCCESS") {
      } else {
        console.log("LOGOUT!!!");
      }
    })
    .catch(err => {
      console.log(err);
    });
};
export default props => {
  const { userinfo, cfg, phonecfg, dispatch } = useContext(AppContext);
  useTitle("마이페이지_설정");

  // 메인, 마이페이지로 이동을 위한 설정 값
  const { fromMain } = props.match.params;

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const [logoutView, setLogoutView] = useState(false);

  const request108 = () => {
    PostApi108(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          // 로그아웃
          dispatch({ type: LOG_OUT_SUCCESS });
          socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
            login: "out",
            userToken: "",
          });
          _O.Open("/");
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleAlert = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".alert-layer"));
  };

  const handleAlertConfirmCB = () => {
    closeLayerFn($(".alert-layer"));
  };

  const handleWithdrawalConfirm = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".confirm-layer"));
  };

  const handleWithdrawalCancelCB = () => {
    closeLayerFn($(".confirm-layer"));
  };

  const handleWithdrawalConfirmCB = () => {
    request108();
    closeLayerFn($(".confirm-layer"));
  };
  // 다이얼로그 ]]

  // useEffect(() => {
  //   $(".onoff-btn").click(function () {
  //     if ($(this).hasClass("on")) {
  //       $(this).removeClass("on");
  //       $(this).addClass("off");
  //     } else if ($(this).hasClass("off")) {
  //       $(this).addClass("on");
  //       $(this).removeClass("off");
  //     }

  //     dispatch({
  //       type: SET_APP_SETINFO,
  //       key: $(this).attr("id"),
  //       data: $(this).hasClass("off") ? "N" : "Y",
  //     });
  //     request1914(
  //       userinfo,
  //       cfg,
  //       phonecfg,
  //       $(this).attr("id"),
  //       $(this).hasClass("off") ? "N" : "Y",
  //       ""
  //     );
  //   });
  // }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <ContainerNew
        Title={"설정"}
        dark={"dark"}
        leftMenu={SubMenu}
        goToUrl={fromMain === "1" ? "/" : "/mp"}>
        <div className="contents">
          <div className="sub-contents">
            <div className="device-link-contain type3">
              <AccessarySettings
                handleAlert={handleAlert}
                userToken={userinfo.userToken}
              />

              <DataSettings />

              <UnitSettings />

              <AlarmSettings />

              <MarketingInformation />

              <PersonalInformationAgree />

              <MemberWithrawal
                handleWithdrawalConfirm={handleWithdrawalConfirm}
              />

              <AppVersion />

              <div
                style={{
                  marginTop: "30px",
                  display: "flex",
                  flexFlow: "column",
                  gap: "15px",
                }}>
                <MenuTitleBox
                  icon="ic14"
                  text="서비스 약관"
                  eventType="onClick"
                  clickEvent={() => _O.OpenMenu("/mp/termsSelect")}
                />
                <MenuTitleBox
                  icon="ic15"
                  text="회사소개"
                  eventType="href"
                  clickEvent={"link:https://mirabellsoft.co.kr/"}
                />
                <MenuTitleBox
                  icon="ic16"
                  text="로그아웃"
                  eventType="onClick"
                  clickEvent={() => setLogoutView(true)}
                />
              </div>
            </div>
          </div>
        </div>
      </ContainerNew>

      <AlertLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        handleConfirmCB={handleAlertConfirmCB}
      />

      <ConfirmLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        handleCancelCB={handleWithdrawalCancelCB}
        handleConfirmCB={handleWithdrawalConfirmCB}
      />
      <NewAlertLogout logoutView={logoutView} setLogoutView={setLogoutView} />
    </Fragment>
  );
};

const AccessarySettings = memo(({ handleAlert, userToken }) => {
  const { phonecfg, userinfo } = useContext(AppContext);
  return (
    <div>
      <div className="round-list">
        <div>
          <a
            href={void 0}
            className="btn-gray"
            onClick={e => _O.OpenMenu("/mp/settings/accessory")}>
            {" "}
            <i className="ic1"></i> 액세서리 설정
          </a>
        </div>
      </div>
    </div>
  );
});

const DataSettings = memo(props => {
  const { userinfo } = useContext(AppContext);
  return (
    <div>
      <div className="round-list">
        <div className="title c-chd">
          <i className="ic2"></i> 데이터 설정
        </div>

        <ItemOnOffLayer
          name="데이터 접근권한"
          id="dataAprchYn"
          key="O"
          isOn={
            userinfo.app &&
            userinfo.app.setInfo &&
            userinfo.app.setInfo.dataAprchYn === "N"
              ? false
              : true
          }
        />

        <div className="btn">
          {/* <a href={void 0} onClick={(e) => _O.OpenMenu("/mp/settings/data")}>개인데이터 공유 및 다운로드</a> */}
          <a href={void 0} onClick={e => _O.OpenMenu("/cnntHspt/1/setting")}>
            병원연동 및 개인데이터 공유
          </a>
        </div>
        <div className="btn">
          <a href={void 0} onClick={e => _O.OpenMenu("/mp/settings/delete")}>
            개인데이터 삭제
          </a>
        </div>
      </div>
    </div>
  );
});

const UnitSettings = memo(props => {
  return (
    <div>
      <div className="round-list">
        <div className="title">
          <i className="ic3"></i> 단위 설정
        </div>
        <div className="btn">
          <a href={void 0} onClick={e => _O.OpenMenu("/mp/settings/units")}>
            혈당 단위설정
          </a>
        </div>
      </div>
    </div>
  );
});

const AlarmSettings = memo(props => {
  const { userinfo } = useContext(AppContext);
  return (
    <div>
      <div className="round-list">
        <div className="title c-chd">
          <i className="ic4"></i> 알림 설정
        </div>

        <ItemOnOffLayer
          name="병원예약 알람"
          op="O"
          id="hsptResrvAlrmYn"
          isOn={
            userinfo.app &&
            userinfo.app.setInfo &&
            userinfo.app.setInfo.hsptResrvAlrmYn === "N"
              ? false
              : true
          }
        />
        <ItemOnOffLayer
          name="문진 알람"
          op="O"
          id="inpryAlrmYn"
          isOn={
            userinfo.app &&
            userinfo.app.setInfo &&
            userinfo.app.setInfo.inpryAlrmYn === "N"
              ? false
              : true
          }
        />
        <ItemOnOffLayer
          name="전자처방전 알람"
          op="O"
          id="prsctAlrmYn"
          isOn={
            userinfo.app &&
            userinfo.app.setInfo &&
            userinfo.app.setInfo.prsctAlrmYn === "N"
              ? false
              : true
          }
        />
        <ItemOnOffLayer
          name="제증명 서류/보험청구 알람"
          op="O"
          id="profAlrmYn"
          isOn={
            userinfo.app &&
            userinfo.app.setInfo &&
            userinfo.app.setInfo.profAlrmYn === "N"
              ? false
              : true
          }
        />
        <ItemOnOffLayer
          name="검사스케쥴 알람"
          op="O"
          id="chkSchdlAlrmYn"
          isOn={
            userinfo.app &&
            userinfo.app.setInfo &&
            userinfo.app.setInfo.chkSchdlAlrmYn === "N"
              ? false
              : true
          }
        />
        <ItemOnOffLayer
          name="복약알람"
          op="O"
          id="mdcnAlrmYn"
          isOn={
            userinfo.app &&
            userinfo.app.setInfo &&
            userinfo.app.setInfo.mdcnAlrmYn === "N"
              ? false
              : true
          }
        />
        <ItemOnOffLayer
          name="자가건강관리 알람"
          op="O"
          id="psnlHlthAlrmYn"
          isOn={
            userinfo.app &&
            userinfo.app.setInfo &&
            userinfo.app.setInfo.psnlHlthAlrmYn === "N"
              ? false
              : true
          }
        />
        <ItemOnOffLayer
          name="개인진료기록 알람"
          op="O"
          id="psnlTrmtHistAlrmYn"
          isOn={
            userinfo.app &&
            userinfo.app.setInfo &&
            userinfo.app.setInfo.psnlTrmtHistAlrmYn === "N"
              ? false
              : true
          }
        />
        <ItemOnOffLayer
          name="전화예약진료 알람"
          op="O"
          id="telResrvAlrmYn"
          isOn={
            userinfo.app &&
            userinfo.app.setInfo &&
            userinfo.app.setInfo.telResrvAlrmYn === "N"
              ? false
              : true
          }
        />
      </div>
    </div>
  );
});

const MarketingInformation = props => {
  const { userinfo } = useContext(AppContext);
  return (
    <div>
      <div className="round-list">
        <div className="title c-chd">
          <i className="ic5"></i> 마케팅 정보
        </div>

        <ItemOnOffLayer
          name="마케팅 정보 앱푸쉬"
          op="O"
          id="mrktPushYn"
          isOn={
            userinfo.app &&
            userinfo.app.setInfo &&
            userinfo.app.setInfo.mrktPushYn === "N"
              ? false
              : true
          }
        />
        <ItemOnOffLayer
          name="마케팅 정보 SMS"
          op="O"
          id="mrktSMSYn"
          isOn={
            userinfo.app &&
            userinfo.app.setInfo &&
            userinfo.app.setInfo.mrktSMSYn === "N"
              ? false
              : true
          }
        />
        <ItemOnOffLayer
          name="마케팅 정보 이메일"
          op="O"
          id="mrktEmailYn"
          isOn={
            userinfo.app &&
            userinfo.app.setInfo &&
            userinfo.app.setInfo.mrktEmailYn === "N"
              ? false
              : true
          }
        />
      </div>
    </div>
  );
};

const PersonalInformationAgree = memo(props => {
  const { userinfo } = useContext(AppContext);
  return (
    <div>
      <div className="round-list">
        <div className="title c-chd">
          <i className="ic6"></i> 개인정보 동의
        </div>

        <ItemOnOffLayer
          name="개인정보 제3자 제공동의"
          id="psnlInfoAgreeYn"
          isOn={
            userinfo.app &&
            userinfo.app.setInfo &&
            userinfo.app.setInfo.psnlInfoAgreeYn === "N"
              ? false
              : true
          }
        />

        <div>
          <p className="mark-left">
            <s>!</s>
            사용자는 개인정보 제 3자 제공동의에 거부권리가 있습니다.
            <br />
            미동의시에는 일부 서비스 이용이 불가합니다.
          </p>
        </div>
      </div>
    </div>
  );
});

const MemberWithrawal = memo(({ handleWithdrawalConfirm }) => {
  return (
    <div>
      <div className="round-list">
        <div className="title c-chd">
          <i className="ic7"></i> 회원탈퇴
        </div>
        <div className="btn">
          <a
            href={void 0}
            className="btn-open-withd"
            onClick={e =>
              handleWithdrawalConfirm(
                "탈퇴",
                "모든 정보 삭제되며 복구가 불가능 합니다.<br />탈퇴 하겠습니까?"
              )
            }>
            회원탈퇴
          </a>
        </div>
      </div>
    </div>
  );
});

const AppVersion = memo(({ handleWithdrawalConfirm }) => {
  const { phonecfg } = useContext(AppContext);
  return (
    <div>
      <div className="round-list">
        <div className="title c-chd">
          <i className="ic12"></i> 버전정보
        </div>
        <div className="rd-box">
          {/* <a href={void 0} 
                        className="btn-open-withd" 
                        // onClick={(e) => handleWithdrawalConfirm('탈퇴', '모든 정보 삭제되며 복구가 불가능 합니다.<br />탈퇴 하겠습니까?')}
                    >
                    </a> */}
          V {phonecfg.version ? phonecfg.version : "1.0.0"} / 1.0.28
        </div>
      </div>
    </div>
  );
});

const MenuTitleBox = memo(props => {
  const { icon, text, clickEvent } = props;
  return (
    <div style={{ marginTop: "0px" }}>
      <div className="round-list">
        <div>
          {props.eventType === "href" ? (
            <a className="btn-gray" href={clickEvent}>
              {" "}
              <i
                className={icon}
                style={{ margin: "0px 3px 2px 0px" }}></i>{" "}
              {text}
            </a>
          ) : (
            <a className="btn-gray" onClick={clickEvent}>
              {" "}
              <i
                className={icon}
                style={{ margin: "0px 3px 2px 0px" }}></i>{" "}
              {text}
            </a>
          )}
        </div>
      </div>
    </div>
  );
});
